import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-transfer-ownership-introduction-card',
    template: `
        <mat-card class="transfer-ownership-card introduction-card">
            <mat-card-title>{{ 'ownership.transfer' | fiAppText }}</mat-card-title>
            <mat-card-content>
                <p class="transfer-ownership-card_content-text">{{ 'ownership.transfer_introduction' | fiAppText }}</p>
            </mat-card-content>
        </mat-card>
    `,
    styleUrl: './fi-transfer-ownership-introduction-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-transfer-ownership-introduction-card' },
    standalone: false,
})
export class FiTransferOwnershipIntroductionCardComponent {}
